<template>
  <div>
    <van-nav-bar
      to="StuList"
      title="添加学生"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="gradeid"
        :value="gradeValue"
        label="年级"
        placeholder="点击选择年级"
        @click="showGradePicker = true"
      />
      <van-popup v-model="showGradePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="gradeColumns"
          @confirm="gradeOnConfirm"
          @cancel="showGradePicker = false"
          :default-index="0"
        />
      </van-popup>

      <van-field
        clearable
        v-model="stuname"
        name="stuname"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        clearable
        v-model="stunum"
        type="number"
        name="stunum"
        label="学号"
        placeholder="学号"
        :rules="[{ required: true, message: '请填写学号' }]"
      />
      <van-field
        clearable
        v-model="classes"
        type="text"
        name="classes"
        label="班级"
        placeholder="班级"
        readonly
        @click="classesShow=true"
        :rules="[{ required: true, message: '请填写班级' }]"
      />
      <van-field
        readonly
        clickable
        name="school"
        :value="schoolValue"
        label="学院(部)"
        placeholder="点击选择学院(部)"
        @click="showSchoolPicker = true"
      />
      <van-popup v-model="showSchoolPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="schoolColumns"
          @confirm="schoolOnConfirm"
          @cancel="showSchoolPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="campusArea"
        :value="campusAreaValue"
        label="校区"
        placeholder="点击选择校区"
        @click="showCampusAreaPicker = true"
      />
      <van-popup v-model="showCampusAreaPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="campusAreaColumns"
          @confirm="campusAreaOnConfirm"
          @cancel="showCampusAreaPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="level"
        :value="levelValue"
        label="学历层次"
        placeholder="点击选择学历层次"
        @click="showLevelPicker = true"
      />
      <van-popup v-model="showLevelPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="levelColumns"
          @confirm="levelOnConfirm"
          @cancel="showLevelPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="gender"
        :value="genderValue"
        label="性别"
        placeholder="点击选择性别"
        @click="showGenderPicker = true"
      />
      <van-popup v-model="showGenderPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="genderColumns"
          @confirm="genderOnConfirm"
          @cancel="showGenderPicker = false"
          :default-index="0"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加学生
        </van-button>
      </div>
    </van-form>

    <van-divider/>

    <div style="text-align:center;">
      <!--      accept=".xls,.xlsx"-->
      <van-uploader accept=".xls,.xlsx" v-model="fileList" :max-count="1" :before-read="before_read"
                    :after-read="after_read" :before-delete="delete_file">
        <van-button round block icon="plus" type="primary">文件导入</van-button>
      </van-uploader>
    </div>

    <van-cell-group>
      <van-cell v-for="(item,index) in FailStudentList" :title="item.sName+' '+item.gender+' '+item.sNum" value="失败"
                :key="index"/>
    </van-cell-group>

    <van-action-sheet v-model="classesShow" title="班级搜索">
      <div class="classesContent">
        <van-search v-model="classesSearchKey" @search="classesSearch" placeholder="请输入不少于两个汉字班级搜索关键词"/>
        <van-cell-group inset>
          <van-cell :class="item.value==classes?'classesSelected':''" @click="classes=item.value,classesShow=false"
                    :title="item.value" :value="item.key" v-for="(item,index) in classesSearchValues" :key="index"/>
        </van-cell-group>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Divider,
  Dialog,
  Uploader,
  CellGroup,
  Cell,
  ActionSheet,
  Search,
  Toast, Sticky
} from 'vant';
import {AddStudent, ClassesSearchByKey} from "@/network/student";
import {upLoadStudents} from "@/network/upLoader";

Vue.use(NavBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(ActionSheet);
Vue.use(Search);
Vue.use(Toast);
Vue.use(Sticky);

export default {
  name: "AddStudent",
  data() {
    return {
      stuname: '',
      stunum: '',
      classes: '',
      classesSearchKey: '',
      classesSearchValues: [],
      gradeValue: '',
      genderValue: '',
      levelValue: '',
      schoolValue: '',
      school: '',
      campusAreaValue:'南校区',
      genderColumns: ['男', '女'],
      levelColumns: ['本科', '专科', '专升本'],
      schoolColumns: ['工学部', '艺体学部', '医学部','商学部','医学院', '商学院', '国际学院', '外国语学院', '应用技术学院', '职业技术学院'],
      gradeColumns: ['2021', '2020', '2019', '2018', '2017', '2016', '2000'],
      campusAreaColumns: ['南校区','济源校区'],
      showGenderPicker: false,
      showLevelPicker: false,
      showSchoolPicker: false,
      showCampusAreaPicker: false,
      classesShow: false,
      showGradePicker: false,
      fileList: [],
      FailStudentList: []
    }
  },
  activated() {
    const grade=this.GLOBAL.grade;
    this.gradeColumns=[];
    for(let i=0;i<5;i++){
      this.gradeColumns.push(grade-i);
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("StuList");
    },
    classesSearch() {
      const key = this.classesSearchKey;
      if (key.length < 2) {
        Toast('请输入不少于两个汉字班级搜索关键词');
        return
      }
      ClassesSearchByKey(key).then(res => {
        this.classesSearchValues = res;
      }).catch(res => {
        this.Dialoginfo('提示', '添加失败');
      })
    },
    onSubmit(values) {
      if (values.gender === "") {
        this.Dialoginfo('提示', '性别不能为空');
      } else if (values.school === "") {
        this.Dialoginfo('提示', '学院(部)不能为空');
      } else if (values.level === "") {
        this.Dialoginfo('提示', '学历层次不能为空');
      } else if (values.gradeid === "") {
        this.Dialoginfo('提示', '年级不能为空');
      } else {
        AddStudent(values.gradeid, values.stunum, values.stuname.trim(), values.gender, values.classes, values.school, values.level,values.campusArea).then(res => {
          if (res) {
            this.Dialoginfo('提示', '添加成功');
          } else {
            this.Dialoginfo('提示', '添加失败');
          }
        }).catch(res => {
          this.Dialoginfo('提示', '添加失败');
        })
      }
    },
    genderOnConfirm(value) {
      this.genderValue = value;
      this.showGenderPicker = false;
    },
    levelOnConfirm(value) {
      this.levelValue = value;
      this.showLevelPicker = false;
    }, schoolOnConfirm(value) {
      this.schoolValue = value;
      this.showSchoolPicker = false;
    },
    campusAreaOnConfirm(value){
      this.campusAreaValue = value;
      this.showCampusAreaPicker = false;
    },
    gradeOnConfirm(value) {
      this.gradeValue = value;
      this.showGradePicker = false;
    },
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    },
    before_read(file) {
      // console.log(file);
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadStudents(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入成功';
          this.FailStudentList = res.failStudents;
          Dialog.alert({
            title: '导入信息',
            message: '成功:' + res.success + ',失败:' + res.fail,
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
        }
      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })

    },
    delete_file() {
      this.FailStudentList = [];
      return true;
    },

  }
}
</script>

<style scoped>
.classesContent {
  padding: 16px 16px 360px;
}

.classesSelected {
  color: #7dbfff;
  font-weight: bold;
}
</style>
